import { useRef, useEffect } from 'react';
import styles from './CTASection.module.css';

/* ── YouTube embed (product walkthrough — controls on, no autoplay) ── */
const YT_ID = '61iN2emMqbs';
const YT_WALKTHROUGH = `https://www.youtube.com/embed/${YT_ID}?rel=0&playsinline=1`;

const VERT_LINE = '/assets/vertical-divider.svg';
const QUOTE_ICON = '/assets/quote-icon.svg';

function useFadeIn() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { el.classList.add('visible'); obs.disconnect(); } },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return ref;
}

export default function CTASection({ handleBtnClick }) {
  const ctaRef = useFadeIn();
  const videoRef = useFadeIn();
  const quoteRef = useFadeIn();

  return (
    <section id="cta" className={styles.section} aria-label="Book a demo">

      {/* ── Green bg area ─────────────────────────────────── */}
      <div className={styles.greenBg}>

        {/* Background orbs */}
        <div className={styles.orbTR} aria-hidden="true" />
        <div className={styles.orbBL} aria-hidden="true" />

        <div className={styles.inner}>

          {/* ── CTA text (left on desktop) ───────────────── */}
          <div ref={ctaRef} className={`${styles.ctaText} fade-in`}>
            <h2 className={styles.heading}>Your next step</h2>
            <p className={styles.subheading}>
              Book a conversation with our <br /> school solutions partner
            </p>
            <button
              onClick={(e) => handleBtnClick(e.target, "Book your Demo CTA")}
              className="wm-btn-primary"
              aria-label="Book your demo with CoSchool"
              style={{ border: 'none', cursor: 'pointer' }}
            >
              Book Walkthrough
            </button>
          </div>

          {/* ── Video (right on desktop) ──────────────────── */}
          <div ref={videoRef} className={`${styles.videoCol} fade-in`}>
            {/* Vertical line */}
            <div className={styles.vertLine} aria-hidden="true">
              <img src={VERT_LINE} alt="" width="1" height="98" loading="lazy" />
            </div>

            {/* YouTube embed — product walkthrough, user-initiated play */}
            <div className={styles.videoFrame}>
              <iframe
                className={styles.video}
                src={YT_WALKTHROUGH}
                title="Product walkthrough for CoSchool"
                allow="encrypted-media; picture-in-picture"
                allowFullScreen
                loading="lazy"
              />
            </div>

            <p className={styles.videoLabel}>Click Above To Watch</p>
          </div>
        </div>
      </div>

      {/* ── Quote section (white bg) ──────────────────────── */}
      <div ref={quoteRef} className={`${styles.quoteSection} fade-in`}>
        <img src={QUOTE_ICON} alt="" width="33" height="36" loading="lazy" aria-hidden="true" />
        <blockquote className={styles.quote}>
          The gap between teaching and learning is where children fall behind. You can close it before it becomes a result.
        </blockquote>
      </div>
    </section>
  );
}
